import ApprovedPRViewDetails from "pages/Procurement/PurchaseOrder/View/ApprovedPRViewDetails";

const TagApprovedPRViewDetails = () => {
  return <ApprovedPRViewDetails />;
};

export default TagApprovedPRViewDetails;
